import { FunctionComponent } from 'react';
import { Div, Loader } from '@gaiads/telia-react-component-library';

import './CustomLoader.scss';

export interface CustomLoaderProps {
  centered?: boolean;
  dimBackground?: boolean;
}

const CustomLoader: FunctionComponent<CustomLoaderProps> = ({ centered = false, dimBackground = false }) => {
  const loader = <Loader {...(centered ? { style: { position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' } } : {})} />;

  if (dimBackground) {
    return <Div className={'loading-dim-overlay'}>{loader}</Div>;
  } else {
    return loader;
  }
};

export default CustomLoader;
